import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=63c1e85b&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=63c1e85b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1e85b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c1e85b')) {
      api.createRecord('63c1e85b', component.options)
    } else {
      api.reload('63c1e85b', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=63c1e85b&scoped=true&", function () {
      api.rerender('63c1e85b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eB1Y6V0rB0EZ/JS/comp/PopupDialog.vue"
export default component.exports